<template>
  <div class="chooseAdress">
    <topTitle title="选择地址"></topTitle>
    <div class="addressList" v-for="(item,index) in list" :key="index" @click="choAdress(item)">
      <div class="listInfo">
        <div class="listTop">
          <p>
            {{item.name}}
            <span>{{item.mobile}}</span>
          </p>
        </div>
        <div class="listbottpm">
          <p>{{item.province}} {{item.city}} {{item.county}} {{item.addr}}</p>
        </div>
      </div>
      <div class="listTool">
        <div>
          <img src="../../assets/img/icon/Shape.png" alt />
          <span @click="editAdress(1,item)">编辑</span>
        </div>
        <div>
          <img src="../../assets/img/icon/trash.png" alt />
          <span @click="scdq(item)">删除</span>
        </div>
      </div>
    </div>
    <!-- <div class="addressList">
      <div class="listInfo">
        <div class="listTop">
          <p>
            西西亚
            <span>18600885522</span>
          </p>
        </div>
        <div class="listbottpm">
          <p>北京市 北京市 朝阳区 北京市朝阳区酒仙桥东路18号尚科办公社区B座5层508室</p>
        </div>
      </div>
      <div class="listTool">
        <div>
          <img src="../../assets/img/icon/Shape.png" alt />
          <span>编辑</span>
        </div>
        <div>
          <img src="../../assets/img/icon/trash.png" alt />
          <span>删除</span>
        </div>
      </div>
    </div> -->
    <div class="newAddress">
      <button @click="editAdress(2)">新建收货地址</button>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
import { Toast } from 'vant';

export default {
  name: "chooseAdress",
  data() {
    return {
      list:[],
	  tapTrue:this.$route.query.addressTapTrue
    };
  },
  components: {
    topTitle
  },

  created() {
    this.getList();
  },

  methods: {
    scdq(obj){
      this.deleteRequest(`members/address/${obj.addr_id}`).then(res => {
        this.getList();
        Toast.success('删除成功');
      })
    },
    getList() {
      this.getRequest( `members/addresses`).then(res => {
        if(res.data.code == 1){
          this.list = [];
          // this.loading = false;
          // this.finished = true;
        }else{
          console.log(res.data.data)
          this.list = res.data.data
          // this.loading = false;
          // // 数据全部加载完成
          // if (res.data.data.data.length < 10) {
          //   this.finished = true;
          // }
        }
      })
    },
	choAdress(item){
		if(this.tapTrue == true){
			this.$router.push({
				path:"./ConfirmationOrder",
				query:{
					changeAdVal:item,
					changeState:true
				}
			});
		}else{
			return false
		}
	},
    editAdress(val,item) {
      if(val == 1){
        this.$router.push({path:'./addAdresInfo',query:{obj:JSON.stringify(item)}})
      }else{
        this.$router.push("./addAdresInfo");
      }
    }
  }
};
</script>


<style scoped lang='less'>
.chooseAdress {
  padding-bottom:160px; 
  .addressList {
    background-color: #fff;
    width: 100%;
    margin-top: 20px;
    .listInfo {
      padding: 20px 30px;
      border-bottom: solid 1px #f1f1f1;
      .listTop {
        color: #333333;
        font-size: 30px;
        margin-bottom: 6px;
      }
      .listbottpm {
        font-size: 26px;
        color: #777777;
      }
    }
    .listTool {
      height: 86px;
      line-height: 86px;
      display: flex;
      justify-content: flex-end;
      div {
        margin-right: 40px;
        img {
          display: inline-block;
          width: 30px;
          height: 30px;
          vertical-align: sub;
          margin-right: 10px;
        }
        span {
          font-size: 28px;
          color: #666666;
        }
      }
    }
  }
  .newAddress {
    padding: 12px 78px;
    position: fixed;
    bottom: 40px;
    width: 100%;
    button {
      background: linear-gradient(to right, #f24c0b, #f2170c);
      width: 100%;
      height: 88px;
      line-height: 88px;
      letter-spacing: 2px;
      font-size: 36px;
      color: #fff;
      border-radius: 40px;
    }
  }
}
</style>


